module.exports = {"svg":{"$":{"t":"1542963895880","class":"icon","style":"","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"1923","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"200","height":"200"},"defs":[{"style":[{"$":{"type":"text/css"}}]}],"path":[{"$":{"d":"M2.5 189.7H1024V60H2.5v129.7z m0 389.2H1024V449.1H2.5v129.8z m0 389.1H1024V838.3H2.5V968z","p-id":"1924"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/assets/svg/three-line.svg
// module id = ciao
// module chunks = 2